import { render, staticRenderFns } from "./EmployerCommunicationsKit.vue?vue&type=template&id=748fbe6c&scoped=true"
import script from "./EmployerCommunicationsKit.vue?vue&type=script&lang=ts"
export * from "./EmployerCommunicationsKit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748fbe6c",
  null
  
)

export default component.exports